// extracted by mini-css-extract-plugin
export default {"heading_container":"Heading_heading_container__eW7Wp","heading":"Heading_heading__v8xfz"};